import React from "react";
import dynamic from 'next/dynamic'
const Carousel = dynamic(() => import('react-multi-carousel'), { 
  ssr: false 
})
import Image from "next/image";
import "react-multi-carousel/lib/styles.css";
import LeftArrow from "./LeftArrow";
import RightArrow from "./RightArrow";

import Timber from "../../../media/images/Timber.png";
import Inspiration from "../../../media/images/Inspiration.png";
import Systems from "../../../media/images/Systems.png";
import Products from "../../../media/images/products.png";
import Applications from "../../../media/images/applications.png";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 375 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};
const sliderImageUrl = [    
    {   url: Timber,
        text: "Timbers",
        href: '/timber',
    },
    {   url: Systems,
        text: "Systems",
        href: '/systems',
    },
    {   url: Inspiration,
        text: "Inspiration",
        href: '/inspiration',
    },
    {   url: Applications,
        text: "Applications",
        href: '/categories',
    },
    {   url: Products,
        text: "Products",
        href: '/systems',
    },
];
const Slider = () => {
  return (
    <div className="parent">        
      <Carousel
        responsive={responsive}
        autoPlay={false}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={true}
        partialVisible={false}
        customLeftArrow={<LeftArrow/>}
        customRightArrow={<RightArrow />}
      >
        {sliderImageUrl.map((imageUrl, index) => {
          return (
            <div className="slider mx-10" key={index}>
              <a className="imageWrapper relative block" href={imageUrl.href}>
                <Image src={imageUrl.url} alt="slide" />
                <span className="absolute inset-0">
                    <h2 className="text-4xl font-semibold text-background absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{imageUrl.text}</h2>
                </span>
              </a>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};
export default Slider;
